/**
 * 运营商后台 - 主题配置文件
 * 主题色：橙色 (#FF8C00)
 * 平台标识：operator
 */

export const platformConfig = {
  // 平台标识
  code: 'operator',
  name: '城市运营商后台',
  
  // 主题色
  theme: {
    primary: '#FF8C00',
    primaryLight: '#FFAA33',
    primaryDark: '#CC7000',
    primaryBg: 'rgba(255, 140, 0, 0.1)',
    primaryGradient: 'linear-gradient(135deg, #CC7000 0%, #FF8C00 100%)',
    
    // 侧边栏
    sidebarBg: '#FF8C00',
    sidebarLogoBg: '#fff',
    sidebarText: '#FF8C00',
    sidebarHover: 'rgba(255, 255, 255, 0.15)',
    
    // 文字颜色
    textPrimary: '#303133',
    textRegular: '#606266',
    textSecondary: '#909399',
    
    // 边框颜色
    borderBase: '#DCDFE6',
    borderLight: '#E4E7ED',
  },
  
  // Logo配置
  logo: {
    // 登录页大logo
    login: '/logo-big.png',
    // 侧边栏小logo
    sidebar: '/logo.png',
    // 顶部导航logo
    header: '/img/hive-logo-horizontal.png',
    // 网页favicon
    favicon: '/favicon.ico'
  },
  
  // 布局配置
  layout: {
    sidebarWidth: '210px',
    sidebarCollapsedWidth: '64px',
    headerHeight: '60px',
    tagsViewHeight: '40px'
  },
  
  // 平台特有功能开关
  features: {
    // 是否显示多标签页
    showTagsView: true,
    // 是否显示面包屑
    showBreadcrumb: true,
    // 是否显示全屏按钮
    showScreenfull: true,
    // 是否显示主题切换
    showThemeSwitch: false,
    // 是否显示大小切换
    showSizeSelect: true
  }
}

export default platformConfig
